/**
 * Классы поля описания нужных данных — одни и те же у свойств диаграммы и у заведения новой.
 *
 * Высоту поле подгоняет под содержимое, поэтому пустое встало бы в одну строку — наименьшую
 * высоту ему задаёт стиль: описание набирается длинным, и разом его видно не менее трёх строк.
 * Переросшее потолок описание прокручивается внутри поля, не растягивая блок свойств.
 */
export const CHART_DESCRIPTION_FIELD_CLASS = 'min-h-24 max-h-40 overflow-y-auto';
